
export const ORDER_INVOICE_EXPORT_ID = 'order-invoice';
export const ORDER_INVOICE_TITLE = 'Facturas de Clientes';


export const LOCALIZED_PROPERTIES = {
  code: 'Codigo_Ruta',
  subRoute: 'Ruta',
  user: 'Usuario',
  serials: 'Nro Doc',
  externalCode: 'Nro Doc Externo',
  date: 'Fecha',
  shipToExternalKey:'Codigo_Cliente',
  shipToName: 'Cliente',
  NIT: 'NIT',
  materialCode: 'Codigo_Material',
  materialName: 'Material',
  soldQuantity: 'Cantidad',
  baseUnitOfMeasureCode: 'UMB',
  pararellQuantity: 'Cantidad UMP',
  pararellUnitOfMeasureCode: 'UMP',
  unitPrice: 'Precio',
  subTotal: 'Subtotal',
  total: 'Total',
  status: 'Estado'
};

